import React from "react";

export default function Privacy() {
  return (
    <section className="ae-section pt-28">
      <div className="ae-container max-w-3xl">
        <div className="ae-eyebrow mb-3">Legal</div>
        <h1 className="font-display text-4xl font-semibold text-[#101827] mb-6">Privacy Policy</h1>
        <div className="prose-ae space-y-4 text-[#1F2937] leading-relaxed">
          <p>This policy describes how Apurba Estate ("we", "us") collects, uses, stores and protects personal information in the course of providing real estate consultancy, land surveying and documentation assistance services.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Information We Collect</h2>
          <p>We collect information you provide via enquiry forms (name, phone, email, property interest, location, budget, message), and operational information required to deliver surveying or documentation services (plot details, mouza, dag number, approximate area, preferred date).</p>
          <h2 className="font-display text-xl font-semibold mt-6">Purpose of Collection</h2>
          <p>Information is used to respond to your enquiry, coordinate services, maintain internal records, and comply with applicable law. We do not sell your personal information.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Data Storage & Third-Party Services</h2>
          <p>Submissions are stored securely in our database. We may use trusted third-party services (hosting, messaging, payment processing) that have their own privacy practices.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Your Rights</h2>
          <p>Subject to applicable law, you may request access, correction or deletion of your personal information by contacting us using the details on our Contact page.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Retention</h2>
          <p>We retain enquiry data for a reasonable period required to serve you and comply with record-keeping obligations.</p>
          <p className="text-sm text-[#64748B] mt-6">This policy will be updated as our services evolve or as required by law.</p>
        </div>
      </div>
    </section>
  );
}
